<div class="d-flex flex-column h-100">
    <div class="d-flex justify-content-between align-items-center">
        <div>
            <app-breadcrumb></app-breadcrumb>
        </div>
        <div>
            <button type="button" class="btn btn-sm btn-info" (click)="loadAll()">
                <i class="fas fa-sync mr-1"></i>
                불러오기
            </button>
        </div>
    </div>

    <div class="row row-cols-2 row-cols-md-4 mt-3">
        <div class="col mb-3">
            <div class="card h-100 mb-0 border shadow-sm">
                <div class="card-header bg-white border-top border-t-w-5 border-info">
                    <div class="h5 font-weight-normal mb-0">
                        현재 운행 차량
                    </div>
                    <div class="text-black-50 mt-1">
                        <span>전체</span>
                        <span class="ml-2">
                            {{carAllCnt | number}} 대
                        </span>
                    </div>
                </div>
                <div class="card-body py-2 d-flex align-items-end">
                    <div class="w-100 d-flex justify-content-end align-items-baseline">
                        <span class="h2 mb-0 font-weight-light">
                            {{carDriveCnt | number}}
                        </span>
                        <span class="h5 mb-0 ml-1 text-black-50">
                            ({{percentCnt(ymdCurr) | number:'0.0-1'}} %)
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="col mb-3">
            <div class="card h-100 mb-0 border shadow-sm">
                <div class="card-header bg-white border-top border-t-w-5 border-info">
                    <div class="h5 font-weight-normal mb-0">
                        전체 운행 거리
                    </div>
                    <div class="text-black-50 mt-1">
                        <span>전일대비</span>
                        <span class="text-danger ml-2">
                            <i class="mdi mdi-arrow-up" *ngIf="percentDist(ymdCurr,ymdBefore1) > 0"></i>
                            <i class="mdi mdi-equal" *ngIf="percentDist(ymdCurr,ymdBefore1) == 0"></i>
                            <i class="mdi mdi-arrow-down" *ngIf="percentDist(ymdCurr,ymdBefore1) < 0"></i>
                            {{ percentDist(ymdCurr,ymdBefore1) | number:'0.0-1'}} %
                        </span>
                    </div>
                </div>
                <div class="card-body py-2 d-flex align-items-end">
                    <div class="w-100 d-flex justify-content-end align-items-baseline">
                        <span class="h2 font-weight-light mb-0">
                            {{ sumDist(ymdCurr) | number:'0.0-1'}}
                        </span>
                        <span class="h5 mb-0 ml-1 text-black-50">
                            km
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="col mb-3">
            <div class="card h-100 mb-0 border shadow-sm">
                <div class="card-header bg-white border-top border-t-w-5 border-info">
                    <div class="h5 font-weight-normal mb-0">
                        전체 운행 시간
                    </div>
                    <div class="text-black-50 mt-1">
                        <span>전일대비</span>
                        <span class="text-danger ml-2">
                            <i class="mdi mdi-arrow-up" *ngIf="percentDuration(ymdCurr,ymdBefore1) > 0"></i>
                            <i class="mdi mdi-equal" *ngIf="percentDuration(ymdCurr,ymdBefore1) == 0"></i>
                            <i class="mdi mdi-arrow-down" *ngIf="percentDuration(ymdCurr,ymdBefore1) < 0"></i>
                            {{ percentDuration(ymdCurr,ymdBefore1) | number:'0.0-1'}} %
                        </span>
                    </div>
                </div>
                <div class="card-body py-2 d-flex align-items-end">
                    <div class="w-100 d-flex justify-content-end align-items-baseline">
                        <span class="h3 font-weight-light mb-0">
                            {{ sumDuration(ymdCurr) | filterSecToTime }}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="col mb-3">
            <div class="card h-100 mb-0 border shadow-sm">
                <div class="card-header bg-white border-top border-t-w-5 border-info">
                    <div class="h5 font-weight-normal mb-0">
                        전체 트립 건수
                    </div>
                    <div class="text-black-50 mt-1">
                        <span>전일대비</span>
                        <span class="text-danger ml-2">
                            <i class="mdi mdi-arrow-up" *ngIf="percentTrip(ymdCurr,ymdBefore1) > 0"></i>
                            <i class="mdi mdi-equal" *ngIf="percentTrip(ymdCurr,ymdBefore1) == 0"></i>
                            <i class="mdi mdi-arrow-down" *ngIf="percentTrip(ymdCurr,ymdBefore1) < 0"></i>
                            {{ percentTrip(ymdCurr,ymdBefore1) | number:'0.0-1'}} %
                        </span>
                    </div>
                </div>
                <div class="card-body py-2 d-flex align-items-end">
                    <div class="w-100 d-flex justify-content-end align-items-baseline">
                        <span class="h2 font-weight-light mb-0">
                            {{ sumTrip(ymdCurr) | number}}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row row-cols-2 row-cols-md-4">
        <div class="col mb-3">
            <div class="card h-100 mb-0 border shadow-sm">
                <div class="card-header bg-white border-top border-t-w-5 border-success">
                    <div class="h5 font-weight-normal mb-0">
                        운행 차량 평균 운행 거리
                    </div>
                    <div class="text-black-50 mt-1">
                        <span>전일대비</span>
                        <span class="text-danger ml-2">
                            <i class="mdi mdi-arrow-up" *ngIf="percentAvgDist(ymdCurr,ymdBefore1) > 0"></i>
                            <i class="mdi mdi-equal" *ngIf="percentAvgDist(ymdCurr,ymdBefore1) == 0"></i>
                            <i class="mdi mdi-arrow-down" *ngIf="percentAvgDist(ymdCurr,ymdBefore1) < 0"></i>
                            {{ percentAvgDist(ymdCurr,ymdBefore1) | number:'0.0-1'}} %
                        </span>
                    </div>
                </div>
                <div class="card-body py-2 d-flex align-items-end">
                    <div class="w-100 d-flex justify-content-end align-items-baseline">
                        <span class="h2 font-weight-light mb-0">
                            {{ avgDist(ymdCurr) | number:'0.0-1'}}
                        </span>
                        <span class="h5 mb-0 ml-1 text-black-50">
                            km
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="col mb-3">
            <div class="card h-100 mb-0 border shadow-sm">
                <div class="card-header bg-white border-top border-t-w-5 border-success">
                    <div class="h5 font-weight-normal mb-0">
                        운행 차량 평균 운행 시간
                    </div>
                    <div class="text-black-50 mt-1">
                        <span>전일대비</span>
                        <span class="text-danger ml-2">
                            <i class="mdi mdi-arrow-up" *ngIf="percentAvgDuration(ymdCurr,ymdBefore1) > 0"></i>
                            <i class="mdi mdi-equal" *ngIf="percentAvgDuration(ymdCurr,ymdBefore1) == 0"></i>
                            <i class="mdi mdi-arrow-down" *ngIf="percentAvgDuration(ymdCurr,ymdBefore1) < 0"></i>
                            {{ percentAvgDuration(ymdCurr,ymdBefore1) | number:'0.0-1'}} %
                        </span>
                    </div>
                </div>
                <div class="card-body py-2 d-flex align-items-end">
                    <div class="w-100 d-flex justify-content-end align-items-baseline">
                        <span class="h3 font-weight-light mb-0">
                            {{ avgDuration(ymdCurr) | filterSecToTime }}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="col mb-3">
            <div class="card h-100 mb-0 border shadow-sm">
                <div class="card-header bg-white border-top border-t-w-5 border-success">
                    <div class="h5 font-weight-normal mb-0">
                        트립 평균 운행 거리
                    </div>
                    <div class="text-black-50 mt-1">
                        <span>전일대비</span>
                        <span class="text-danger ml-2">
                            <i class="mdi mdi-arrow-up" *ngIf="percentAvgTripDist(ymdCurr,ymdBefore1) > 0"></i>
                            <i class="mdi mdi-equal" *ngIf="percentAvgTripDist(ymdCurr,ymdBefore1) == 0"></i>
                            <i class="mdi mdi-arrow-down" *ngIf="percentAvgTripDist(ymdCurr,ymdBefore1) < 0"></i>
                            {{ percentAvgTripDist(ymdCurr,ymdBefore1) | number:'0.0-1'}} %
                        </span>
                    </div>
                </div>
                <div class="card-body py-2 d-flex align-items-end">
                    <div class="w-100 d-flex justify-content-end align-items-baseline">
                        <span class="h2 font-weight-light mb-0">
                            {{ avgTripDist(ymdCurr) | number:'0.0-1'}}
                        </span>
                        <span class="h5 mb-0 ml-1 text-black-50">
                            km
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="col mb-3">
            <div class="card h-100 mb-0 border shadow-sm">
                <div class="card-header bg-white border-top border-t-w-5 border-success">
                    <div class="h5 font-weight-normal mb-0">
                        트립 평균 운행 시간
                    </div>
                    <div class="text-black-50 mt-1">
                        <span>전일대비</span>
                        <span class="text-danger ml-2">
                            <i class="mdi mdi-arrow-up" *ngIf="percentAvgTripDuration(ymdCurr,ymdBefore1) > 0"></i>
                            <i class="mdi mdi-equal" *ngIf="percentAvgTripDuration(ymdCurr,ymdBefore1) == 0"></i>
                            <i class="mdi mdi-arrow-down" *ngIf="percentAvgTripDuration(ymdCurr,ymdBefore1) < 0"></i>
                            {{ percentAvgTripDuration(ymdCurr,ymdBefore1) | number:'0.0-1'}} %
                        </span>
                    </div>
                </div>
                <div class="card-body py-2 d-flex align-items-end">
                    <div class="w-100 d-flex justify-content-end align-items-baseline">
                        <span class="h3 font-weight-light mb-0">
                            {{ avgTripDuration(ymdCurr) | filterSecToTime}}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row row-cols-2 row-cols-md-4 flex-grow-1">
        <div class="col mb-3">
            <div class="card h-100 mb-0 border shadow-sm">
                <div class="card-header bg-white border-top border-t-w-5 border-warning">
                    <div class="h5 font-weight-normal mb-0">
                        운행 거리 Max 3
                    </div>
                </div>
                <ul class="list-group list-group-flush">
                    <ng-container *ngFor="let item of listCarUseDistMax | sortBy:'desc':'dtgDistAccumul';let idx = index;">
                        <ng-container *ngIf="idx < 3">
                            <li class="list-group-item d-flex justify-content-between align-items-center py-1">
                                <span>
                                    <i class="mdi mdi-crown"
                                        [class.text-gold]="idx === 0"
                                        [class.text-silver]="idx === 1"
                                        [class.text-bronze]="idx === 2"></i>
                                    <span class="ml-1">{{item.dtgCarNo}}</span>
                                </span>
                                <span>
                                    <span>{{(item.dtgDistAccumul * 0.001) | number:'0.0-1'}}</span>
                                    <span class="ml-1">km</span>
                                </span>
                            </li>
                        </ng-container>
                    </ng-container>
                </ul>
            </div>
        </div>

        <div class="col mb-3">
            <div class="card h-100 mb-0 border shadow-sm">
                <div class="card-header bg-white border-top border-t-w-5 border-warning">
                    <div class="h5 font-weight-normal mb-0">
                        운행 시간 Max 3
                    </div>
                </div>
                <ul class="list-group list-group-flush">
                    <ng-container *ngFor="let item of listCarUseDurMax | sortBy:'desc':'dtgRegDtDuration';let idx = index;">
                        <ng-container *ngIf="idx < 3">
                            <li class="list-group-item d-flex justify-content-between align-items-center py-1">
                                <span>
                                    <i class="mdi mdi-crown"
                                        [class.text-gold]="idx === 0"
                                        [class.text-silver]="idx === 1"
                                        [class.text-bronze]="idx === 2"></i>
                                    <span class="ml-1">{{item.dtgCarNo}}</span>
                                </span>
                                <span>
                                    <span>{{item.dtgRegDtDuration | filterSecToTime}}</span>
                                </span>
                            </li>
                        </ng-container>
                    </ng-container>
                </ul>
            </div>
        </div>

        <div class="col mb-3">
            <div class="card h-100 mb-0 border shadow-sm">
                <div class="card-header bg-white border-top border-t-w-5 border-warning">
                    <div class="h5 font-weight-normal mb-0">
                        운행 거리 비교
                    </div>
                </div>
                <div class="card-body p-2">
                    <div class="w-100 h-100 overflow-hidden" #pChart01>
                        <div id="chart01">chart01</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col mb-3">
            <div class="card h-100 mb-0 border shadow-sm">
                <div class="card-header bg-white border-top border-t-w-5 border-warning">
                    <div class="h5 font-weight-normal mb-0">
                        운행 시간 비교
                    </div>
                </div>
                <div class="card-body p-2">
                    <div class="w-100 h-100 overflow-hidden" #pChart02>
                        <div id="chart02">chart02</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="text-warning bg-white shadow-sm p-2 small">
        <div class="">
            <i class="far fa-bell mr-2"></i>
            <span>자료는 1일전 까지만 집계되어 표시됩니다</span>
        </div>
        <div class="mt-2 d-flex justify-content-between align-items-center">
            <div>
                <i class="far fa-bell mr-2"></i>
                <span>페이지 진입시 데이터가 자동으로 표시되지 않으며 검색버튼을 눌러야 표시됩니다</span>
            </div>
        </div>
    </div>
</div>